module.exports = __webpack_public_path__ + "static/homepage-sections-manager-06b53bfc26eec46ccd49b6e946149d38.png";